import cmnSugi from './modules/common_sugi';
import scrlAct from './modules/scroll_act';
// import barbaSetting from './modules/barba_setting';
import slides from './modules/slides';


// import line from './modules/line';

// import bodyscr from './modules/bodyscroll';

// import imagesLoaded from 'imagesloaded';// eslint-disable-line
// import slick from 'slick-carousel';// eslint-disable-line


/*main*/

// $(window).on('load',function(){

//   setTimeout(() => {

//     // // slick02
//     // var $slider = $('.top-mv-slider-slide');
//     // $slider.slick({
//     //   autoplay: true,
//     //   arrows: true,
//     //   dots: true,
//     //   speed: 3000,
//     //   slidesToShow: 2
//     // });
    
//     // $slider.on('afterChange', function(slick, currentSlide){// eslint-disable-line
//     //   console.log('スライド切り替え後のイベント');
//     // });

//     // $('.top-mv-slider-slide').slick({
//     //   autoplay: true,
//     //   arrows: true,
//     //   dots: true,
//     //   responsive: [
//     //     {
//     //       breakpoint: 768,
//     //       settings: {
//     //         arrows: false,
//     //         dots: true,
//     //       }
//     //     },
//     //     {
//     //       breakpoint: 640,
//     //       settings: {
//     //         arrows: false,
//     //         dots: false,
//     //       }
//     //     },
//     //   ]
//     // });

//   },300);
// });



// make Masonry a jQuery plugin
// jQueryBridget( 'masonry', Masonry, $ );

// now you can use $().masonry()
// $('.grid').masonry({
//   itemSelector: '.grid-item',
//   columnWidth: 400
// });

// imagesLoaded('.grid', () => {
//   new Masonry(document.querySelector('.grid'), {
//     itemSelector: '.grid-item',
//     gutter: 50
//   });
// });


cmnSugi();
scrlAct();
slides();
// bodyscr();
// line();
// barbaSetting();

// top hero
// let wW = $(window).width();
// let wH = $(window).height();
// let headH = 120;

// if (window.matchMedia('(max-width: 767px)').matches) {
//   let wHsp = 300;
//   $('#hero').css({'width': wW, 'height': wHsp});
// } else if (window.matchMedia('(min-width:768px)').matches) {
//   $('#hero').css({'width': wW, 'height': wH - headH});
// }


// // resize
// let prewidth = $(window).width();
// $(window).resize(function() {
//   let nowWidth = $(window).width();
//   //let wH = $(window).height();
//   let wWr = $(window).width();
//   let wHr = $(window).height();
//   let headHr = 120;
//   if(prewidth !== nowWidth){
//     if (window.matchMedia('(max-width: 767px)').matches) {
//       let wHspr = 300;
//       $('#hero').css({'width': wWr, 'height': wHspr});
//     } else if (window.matchMedia('(min-width:768px)').matches) {
//       $('#hero').css({'width': wWr, 'height': wHr - headHr});
//     }
//   }
//   prewidth = nowWidth;
// });